import React from 'react';
import { getIcon } from 'flow/utils/social-integration-utils';
import useAppContext from 'flow/hooks/useAppContext';
import Button from 'flow/components/ui-components/Button';

export interface ExternalSigninButtonProps {
    type: 'google' | 'microsoft' | 'oidc' | string;
    clickHandler: () => void;
}

const ExternalSigninButton: React.FC<ExternalSigninButtonProps> = ({
    type,
    clickHandler,
}) => {
    const { i18next } = useAppContext();

    const getIconByType = () => {
        if (type === 'google') {
            return getIcon('google', 18);
        } else if (type === 'microsoft') {
            return getIcon('microsoft', 18);
        } else {
            return null;
        }
    };

    const getLabel = () => {
        if (type === 'google') {
            return i18next.t('signin.google');
        } else if (type === 'microsoft') {
            return i18next.t('signin.microsoft');
        } else if (type === 'oidc') {
            return i18next.t('signin.oidc');
        } else {
            return null;
        }
    };

    return (
        <Button
            type="button"
            className="flex w-full items-center justify-start rounded-sm bg-white shadow-sm dark:bg-gray-200"
            onClick={clickHandler}
        >
            <span className="flex items-center">{getIconByType()}</span>
            <span className="flex h-6 flex-1 items-center justify-center-safe text-center text-base">
                {getLabel()}
            </span>
        </Button>
    );
};

export default React.memo(ExternalSigninButton);
